// App-specific definitions for use in shared code.
// The shared code imports this. Everything defined here should have a counterpart
// in the client-next/src/sharedCodeDependencies.
export const electronModule = null;



// WEBPACK FOOTER //
// ./src/sharedCodeDependencies.js